import React from 'react';
import classes from "./HomePage.module.css";
import BannerSection from '../../sections/BannerSection';
import { Container } from 'react-bootstrap';
import AboutSection from '../../sections/AboutSection';
import ExpertiseSection from '../../sections/ExpertiseSection';
import FAQs from '../../sections/FAQs';
import ContactSection from '../../sections/ContactSection';
import Footer from '../../components/Footer';
import SliderSection from '../../sections/SliderSection';
import { ToastContainer } from 'react-toastify';

export default function HomePage() {
  return (
    <Container fluid className='p-0'>
      <ToastContainer />
        <BannerSection />
      <div className={classes.sectionDiv} id="about">
        <AboutSection />
      </div>
      <SliderSection />
      <div className={classes.blackDiv} id="services">
        <ExpertiseSection />
      </div>
      <FAQs />
      <div className={classes.sectionDiv} id="contact">
        <ContactSection />
      </div>
      <div className={classes.footerDiv}>
        <Footer />
      </div>
    </Container>
  )
}
